import { render, staticRenderFns } from "./relative-time.vue?vue&type=template&id=1153acdc&"
import script from "./relative-time.vue?vue&type=script&lang=ts&"
export * from "./relative-time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports